import { OTC_BLOTTER_PREFIX } from '@src/containers/Blotters/OTC/OTCDerivatives/tokens';
import { shouldRunBlotterTabsMigration } from '../../blotterTabsMigrationVersion';
import { migrateLegacyTabsIntoTradingBlotterPanels } from '../blotterTabsMigrationHelpers';
import type { AppConfigStateWithLegacyLayoutConfigs } from '../legacyLayoutConfigs.types';

/** Moves legacy OTC derivatives tabs into OTC derivatives blotter panel params. */
export function migrateOTCDerivativesBlotterTabsToPanelParams(initialConfig: unknown) {
  const config = initialConfig as AppConfigStateWithLegacyLayoutConfigs;
  if (!shouldRunBlotterTabsMigration(config)) {
    return;
  }
  const legacyOTCTabs = config.tabs?.[OTC_BLOTTER_PREFIX];
  if (legacyOTCTabs == null) {
    return;
  }

  migrateLegacyTabsIntoTradingBlotterPanels(config, {
    legacyTabs: legacyOTCTabs,
    blotterType: 'otcDerivatives',
  });
}
